const TIPO_ADJUNTO = {
  MP3: 1,
  PDF: 2,
  PNG: 3,
  JPG: 4,
};

export default TIPO_ADJUNTO;
